import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Icon } from '@/shared/components/icon/icon';
import { IconsEnum, IconSize } from '@/shared/enums';

@Component({
  selector: 'bevvi-widget',
  imports: [Icon],
  templateUrl: './widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: block;' },
})
export class Widget {
  public readonly expanded = input(false);
  public readonly disabled = input(false);

  public readonly buttonClick = output<void>();

  protected readonly iconsEnum = IconsEnum;
  protected readonly iconSize = IconSize;
}
